<template>
  <div class="loading-overlay">
    <span class="icon">
      <i v-if="errorMessage" class="fas fa-3x fa-times"></i>
      <i v-else class="fas fa-3x fa-circle-notch fa-spin"></i>
    </span>
    <div class="error" v-if="errorMessage">
      <p>{{errorMessage}}</p>
      <button class="button" @click="retry()">Retry</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loadingOverview',
  props: {
    errorMessage: [String, Error]
  },
  methods: {
    retry () {
      this.$emit('retry')
    }
  }
}
</script>

<style scoped>
.icon {
  height: auto;
  width: 100%;
  margin-top: 33vh;
}
.error {
  text-align: center;
}
</style>
